<template>
  <header class="site-header">
    <div class="nav-bar" :class="{ 'color-bar': currentPage !== 'home' }">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex flex-wrap justify-content-between align-items-center">
            <div class="site-branding d-flex align-items-center">
              <router-link to="/"><img class="d-block tsu-logo" src="@/assets/images/logo.png" alt="logo" /></router-link>
            </div>
            <nav
              class="site-navigation d-flex justify-content-end align-items-center"
              :class="{ show: isMenuOpen }"
            >
              <ul
                class="d-flex flex-column flex-lg-row justify-content-lg-end align-content-center"
              >
                <li :class="{ 'current-menu-item': currentPage === 'home' }">
                  <router-link to="/" @click="currentPage = 'home'">หน้าหลัก</router-link>
                </li>
                <li :class="{ 'current-menu-item': currentPage === 'about' }">
                  <router-link to="/about" @click="currentPage = 'about'">เกี่ยวกับเรา</router-link>
                </li>
                <li>
                  <a href="https://pdpa.tsu.ac.th/" target="_blank">นโยบายความเป็นส่วนตัว</a>
                </li>
                <li :class="{ 'current-menu-item': currentPage === 'Howto' }">
                  <router-link to="/how-to" @click="currentPage = 'Howto'">วิธีบริจาค</router-link>
                </li>
                <li>
                  <a
                    href="https://app.powerbi.com/view?r=eyJrIjoiNDMzMzMxY2EtNWNjMy00NGJlLThkZjctYjg1YWM0ZTI4NWRlIiwidCI6IjNkYTdmOTQ3LTY3NTAtNDYzMC04MDk2LWJiYTlmNzZlMjZhOCIsImMiOjEwfQ%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                  >รายงาน</a>
                </li>
              </ul>
            </nav>
            <div class="hamburger-menu d-lg-none" @click="toggleMenu">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

const isMenuOpen = ref(false);
const currentPage = ref('home');
const route = useRoute();

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const updateCurrentPage = () => {
  const currentPath = route.path;
  if (currentPath === '/') {
    currentPage.value = 'home';
  } else {
    const pathParts = currentPath.split('/');
    currentPage.value = pathParts[1];
  }
};

onMounted(() => {
  updateCurrentPage();
});

watch(() => route.path, () => {
  updateCurrentPage();
});
</script>

<style scoped>
/*large desktop */
@media (min-width: 1280px) {
  .tsu-logo {
    width: 600px;
    height: 80px;
  }
}
/*large desktop */
@media (min-width: 1025px) and (max-width: 1279px) {
  .tsu-logo {
    width: 400px;
    height: 60px;
  }
}
/*  tablet */
@media (min-width: 680px) and (max-width: 1024px) {
  .tsu-logo {
    width: 350px;
    height: 50px;
  }
}
/* mobile  */
@media (max-width: 428px) {
  .tsu-logo {
    width: 250px;
    height: 40px;
  }
}
.tsu-logo {
  aspect-ratio: 16/9;
}
.color-bar {
  box-shadow: #ff5a0066 0px 5px, #ee8e354d 0px 10px, #93c3ef33 0px 15px, #2eccf01a 0px 20px,
    #87d9f90d 0px 25px;
}
.color-bar1 {
  box-shadow: rgba(45, 84, 242, 0.4) 0px 5px, rgba(53, 173, 238, 0.3) 0px 10px,
    rgba(147, 195, 239, 0.2) 0px 15px, rgba(46, 204, 240, 0.1) 0px 20px,
    rgba(135, 217, 249, 0.05) 0px 25px;
}
</style>